import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import TextField from "@material-ui/core/TextField";
import { CommonCss } from "../../services/CommonCss";
import { HeaderCommonCss } from "./HeaderCss";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import MenuAbout from "./MenuAbout";
import MenuHelp from "./MenuHelp";
import MenuWhatwedo from "./MenuWhatwedo";
import MenuSustainability from "./MenuSustainability";
import MenuCustomer from "./MenuCustomer";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { getCookie } from "../../services/Cookies";
import { useDispatch } from "react-redux";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import axios from "axios";
import { passwordObj } from "../../pages/account/FormFormat"
import { LOADING } from "../../action";
import { cookieKeys } from "../../services/Cookies";
import { cookieObj } from "../../models/cookieObj";
import { postRequest, getRequest, putRequest } from "../../services/ApiServices";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ListItemButton from '@mui/material/ListItemButton';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemText from '@mui/material/ListItemText';


// import CloseIcon from '@material-ui/icons/Close';

import reactSelect from "react-select";
import ShipData from "../../pages/shipdetails/ShipData";
import { styles } from "@material-ui/pickers/views/Calendar/Calendar";

const useStyles = makeStyles((theme) => ({
  mainHeader: {
    paddingTop: "10px",
    position: "relative",
  },
  subMenuList: {
    textTransform: "uppercase",
    cursor: "pointer",
    textDecoration: "none",
    display: "block",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },

  notiicon: {
    color: "#ff4717",
    background: "#fff !important",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    background: "#fff !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  // flag: {
  //   padding: "4px 22px",
  //   marginRight: "8px"
  // },


  subMenuMain: {
    "& div:hover .beforeLoginIcon, & div:hover > a, & div:hover > span": {
      filter:
        "invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)",
      color: "#FF4717 !important",
    },
  },


}));
export default function Header(props) {
  // debugger
  const commonClasses = CommonCss();
  const headerClasses = HeaderCommonCss();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openReset, setOpenReset] = React.useState(getCookie('resetPassword') === 'true' ? true : false);
  const [openUrl, setOpenUrl] = React.useState("");
  const [imgUrl, setImgUrl] = React.useState("");
  const [passwordFormObj, setPasswordFormObj] = useState(passwordObj);
  const dispatch = useDispatch();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [schedulerShip, setSchedulerShip] = React.useState([]);
  // const [notiicon, setnotiicon] = React.useState()
  // const [noticlear, setnoticlear] = React.useState(true);


  const getNotificationschedular = () => {
    //debugger
    // const url =
    //   process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
    //   "Scheduler/NotificationHeadership";
    // dispatch({ type: LOADING, payload: true });
    // getRequest(url)
    //   .then((res) => {
    //     if (res.status == 200) {
    //       dispatch({ type: LOADING, payload: false });
    //       // console.log('GetNotification value',res.data);
    //       let filterschedulership = res?.data.filter((filterdata) => filterdata.flag == "OverDue" || filterdata.flag == "Due" || filterdata.flag == "Due Soon")
    //       setSchedulerShip([...filterschedulership]);
    //       console.log("filterschedulership : ", filterschedulership)

    //     } else {

    //       dispatch({ type: LOADING, payload: false });
    //       ToastError(res.data.message);
    //     }
    //   })
    //   .catch((error) => {

    //     ToastError(error.response.data.message);
    //     dispatch({ type: LOADING, payload: false });
    //   });
  }


  useEffect(() => {
    getNotificationschedular();

  }, []);
  const handleClick = (event) => {
    // debugger
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      "Scheduler/NotificationHeadership";
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          // console.log('GetNotification value',res.data);
          let filterschedulership = res?.data.filter((filterdata) => filterdata.groupFlag == "OverDue" || filterdata.groupFlag == "Due" || filterdata.groupFlag == "Due Soon")
          setSchedulerShip([...filterschedulership]);
          console.log("filterschedulership : ", filterschedulership)

        } else {

          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {

        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
    setAnchorEl(event.currentTarget);
  };
  const Notificationschedule = (ship) => {
    debugger
    // api/Scheduler/NotificationHeaderShip

    setAnchorEl(false);
    history.push("/dashboard/Notificationscheduler/" + ship);

  };

  // const ClickClose = () => {
  //   // debugger;

  // };

  const Open = Boolean(anchorEl);
  // debugger;
  const id = Open ? 'simple-popover' : undefined;

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };


  useEffect(() => {
    //getNotificationschedular();
    if (getCookie("profileImg"))
      onDownloadProfilePic(getCookie("profileImg"));
  }, []);
  const onDownloadProfilePic = (data) => {
    // //console.log(path)
    dispatch({ type: LOADING, payload: true });
    const token = getCookie("token");
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Account/DownloadProfilePic`;
    let filedata = JSON.stringify({ fileName: data });
    // //console.log(formObj.picturepath );
    let config = {
      method: "post",
      responseType: "blob",
      url: url,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: " image/jpeg,image/png,image/gif"
      },
      data: filedata,
    };
    axios(config)
      .then(async function (response) {
        //console.log(response);
        if (response.status == 200) {
          dispatch({ type: LOADING, payload: false });
          const file = new Blob([response.data], { type: "image/jpeg,image/png,image/gif" });
          //Build a URL from the file
          //console.log(file)
          const fileURL = URL.createObjectURL(file);
          //console.log(fileURL);
          setImgUrl(fileURL);
          // const userData = {profileImgPath : imgUrl}
          // cookieKeys(userData, 30 * 60);

        } else {
          ToastError(response.data.message);
        }
      })
      .catch(function (error) {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
      });
  };
  const handleClickOpen = (url) => {
    if (props.username) {
      setOpenUrl(url);
      setOpen(true);
    } else {
      window.location = process.env.REACT_APP_PUBLIC_URL + url;
    }
  };

  const handleClose = (status) => {
    if (status) {
      window.location = process.env.REACT_APP_PUBLIC_URL + openUrl;
    }
    setOpen(false);
    setOpenUrl("");
  };

  const handleResetClose = (status) => {
    setOpenReset(status);
  };

  const changePass = () => {
    //console.log(passwordFormObj,'test');
    if (!passwordFormObj.oldPassword) {
      ToastError("Old password is required");
    } else
      if (!passwordFormObj.newPassword) {
        ToastError("New password is required");
      } else
        if (!passwordFormObj.confirmPassword) {
          ToastError("Confirm password is required");
        } else
          if (passwordFormObj.newPassword == passwordFormObj.confirmPassword) {
            updatePasswordDetails(passwordFormObj);
          } else {
            ToastError("New password and Confirm password not matched");
          }

  }

  const onChangePwdText = (event) => {
    setPasswordFormObj({ ...passwordFormObj, [event.target.name]: event.target.value });
  }
  const onAccountclick = () => {
    history.push("/dashboard/account");
  }
  const updatePasswordDetails = async (dataObj) => {

    dispatch({ type: LOADING, payload: true });
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Account/UpdatePassword`;
    //console.log(dataObj);
    await putRequest(url, dataObj).then((res) => {
      dispatch({ type: LOADING, payload: false });
      setPasswordFormObj({ ...passwordFormObj, newPassword: "", oldPassword: "", confirmPassword: "" });
      cookieKeys(cookieObj, 0);
      setTimeout(function () {
        history.push("/sign-in");
      }, 100);
      //console.log(res);
    })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        if (error.response.data) {
          if (error.response.data.length) {
            let errMsg = [];
            error.response.data.forEach((msg) => {
              errMsg.push(msg.description);
            });
            ToastError(errMsg.join("<br>"));
          } else {
            ToastError(error.response.data.message);
          }
        }
        //console.log(error);
      });  
  }

  //console.log(imgUrl);
  return (
    <div className={commonClasses.navContainer, "topnav"}>
      <Dialog open={openReset}
        onClose={() => { handleResetClose(true) }} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Reset Password</DialogTitle>
        <DialogContent>
          <Box>
            <Box display="flex">
              <Box width={1}>
                <Box display="flex" alignItems="center" pb={1}>
                  <Box component="span" fontWeight="600" width={0.5}>
                    {"Current Password"}
                  </Box>
                  <Box component="span" width={0.5}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      type="password"
                      required
                      fullWidth
                      value={passwordFormObj.oldPassword}
                      name="oldPassword"
                      onChange={(e) => { onChangePwdText(e) }}
                      className={classes.txtInput}
                    // onChange={(e) => setPass(e.target.value)}
                    />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" pb={1}>
                  <Box component="span" fontWeight="600" width={0.5}>
                    {"New Password"}
                  </Box>
                  <Box component="span" width={0.5}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      type="password"
                      required
                      fullWidth
                      value={passwordFormObj.newPassword}
                      name="newPassword"
                      onChange={onChangePwdText}
                      className={classes.txtInput}
                    // onChange={(e) => setPass(e.target.value)}
                    />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" pb={1}>
                  <Box component="span" fontWeight="600" width={0.5}>
                    {"Confirm New Password"}
                  </Box>
                  <Box component="span" width={0.5}>
                    <TextField
                      type="password"
                      variant="outlined"
                      margin="dense"
                      required
                      fullWidth
                      value={passwordFormObj.confirmPassword}
                      name="confirmPassword"
                      onChange={onChangePwdText}
                      className={classes.txtInput}
                    // onChange={(e) => setPass(e.target.value)}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box component="flex">
              <Box width={1} pb={4} pt={2} textAlign="center">
                <Button className={classes.btnStyle2} onClick={changePass} >
                  Reset Password
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      <Dialog
        open={open}
        onClose={() => { handleClose(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className="link-popup">
          <HighlightOffIcon onClick={() => { handleClose(false) }} />
          <DialogTitle id="alert-dialog-title"></DialogTitle>
          <DialogContent>

            <Box
              component="img"

              display="block"
              margin="auto"
              className={" warning"}
              pb={1}
              src={process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/svg/Warning.svg"}
            />
            <DialogContentText id="alert-dialog-description">
              You are about to leave this page. You can come back by clicking on the Customer portal link under the
              Customer Icon  <Box
                pl={1}
                component="img"
                src={process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/svg/customer-new.svg"}
              />

            </DialogContentText>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to continue to the website?
            </DialogContentText>

          </DialogContent>
          <DialogActions className="button-center custpop1"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Button onClick={() => { handleClose(false) }} className="btn-style1">
              Cancel
            </Button>
            <Button onClick={() => { handleClose(true) }} className={classes.btnStyle2}>
              Continue
            </Button>
          </DialogActions>
        </div>

      </Dialog>
      <Box
        display="flex"
        className={clsx(
          commonClasses.justifyContentBetween,
          classes.mainHeader + " topnavspace"
        )}
        alignItems="flex-end"
      >
        <Box pl={3} width="auto">
          <Box display="flex" py={3}>
            <Box
              textAlign="center"
              className="mainlogo"
              component="a"
              onClick={() => { handleClickOpen("") }}
            //href={process.env.REACT_APP_PUBLIC_URL}

            >
              <Box
                component="img"
                maxWidth={100}
                display="block"
                margin="auto"
                className={commonClasses.cursorPointer + " logo"}
                pb={1}
                src={process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/svg/logo.svg"}
              //onClick={()=>{handleClickOpen("assets/svg/logo.svg")}}
              />
              <Box
                component="img"
                maxWidth={300}
                display="block"
                className={commonClasses.cursorPointer + " maincaption"}
                src={process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/svg/logo-caption.svg"}
              //onClick={()=>{handleClickOpen("assets/svg/logo-caption.svg")}}
              />
            </Box>
          </Box>
        </Box>
        <Box className="mainnav">
          <Box display="flex" className={clsx(headerClasses.navBoxMenu)}>
            <Box className={clsx(headerClasses.menuItem, "menuItem")}
              component="a"
            >
              <Box onClick={() => { handleClickOpen("about.html") }} > About </Box>
              <MenuAbout username={props.username} />
            </Box>
            <Box className={clsx(headerClasses.menuItem, "menuItem")}
              component="a" >
              <Box onClick={() => { handleClickOpen("what-we-do.html") }}> What We Do</Box>
              <MenuWhatwedo username={props.username} />
            </Box>
            <Box
              className={clsx(headerClasses.menuItem, "menuItem")}
              component="a"
            >
              <Box
                onClick={() => { handleClickOpen("knowledge-centre-landing.html") }} >Knowledge Centre </Box>
            </Box>
            <Box className={clsx(headerClasses.menuItem, "menuItem")} component="a"
            >
              <Box onClick={() => { handleClickOpen("sustainability.html") }} >Sustainability</Box>
              <MenuSustainability username={props.username} />
            </Box>
          </Box>
        </Box>
        <Box className="rightnavbar">
          <Box
            display="flex"
            className={clsx(
              commonClasses.justifyContentBetween,
              classes.subMenuMain
            )}
            alignItems="center"
          >
            <Box px={3} textAlign="center" pb={5}  >
              <Box
                component="img"
                width={20}
                className={commonClasses.cursorPointer}

              //onClick={()=>{handleClickOpen("assets/svg/search-new.svg")}}
              ></Box>

              <div display={props.username ? "none" : "block"}
              >
                <div >
                  <IconButton aria-label="upload picture"
                    component="label"
                    aria-describedby={id}
                    onClick={handleClick}>
                    <NotificationsActiveOutlinedIcon className={setSchedulerShip.length > 0 ? classes.notiicon : ""} />
                  </IconButton>
                  <Box
                    component="a"
                    // href={process.env.REACT_APP_PUBLIC_URL + "search.html"}
                    className={clsx(
                      classes.subMenuList,
                      commonClasses.cursorPointer
                    )}
                    onClick={handleClick}
                  >
                    Notification
                  </Box>

                </div>
                <Popover
                  id={id}
                  open={Open}
                  anchorEl={anchorEl}
                  onClose={handlePopoverClose}
                  disableRestoreFocus
                  // onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'Bottom',
                    horizontal: 'Right',
                  }}
                >

                  <List
                    sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                      <ListSubheader component="div" id="nested-list-subheader">
                      </ListSubheader>
                    }
                  >
                    {schedulerShip.map((ShipData) => {

                      return <ListItemButton onClick={() => { Notificationschedule(ShipData.currentVesselName) }}>
                        <ListItemText primary={<>{ShipData.customerName}<br />{ShipData.currentVesselName}</>}
                          secondary={<div style={{ color: ShipData.groupFlag == 'OverDue' ? "Red" : 'orange' }} >{ShipData.groupFlag}</div>} />
                        {/* <div  style={{color:ShipData.groupFlag=='OverDue'?"Red":'orange' }} >{ShipData.groupFlag}</div> */}
                      </ListItemButton>

                    })}

                  </List>
                </Popover>
              </div>
            </Box>
            <Box textAlign="center" pb={1}>
              <Box
                component="img"
                width={20}
                className={commonClasses.cursorPointer}
                src={process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/svg/search-new.svg"}
              //onClick={()=>{handleClickOpen("assets/svg/search-new.svg")}}
              ></Box>
              <Box
                component="a"
                // href={process.env.REACT_APP_PUBLIC_URL + "search.html"}
                pt={1}
                className={clsx(
                  classes.subMenuList,
                  commonClasses.cursorPointer
                )}
                onClick={() => { handleClickOpen("search.html") }}
              >
                Search
              </Box>
            </Box>

            <Box px={3} textAlign="center" pb={1}>
              <Box
                component="img"
                width={20}
                className={clsx(commonClasses.cursorPointer, "beforeLoginIcon")}
                src={process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/svg/webshop-new.svg"}
              //onClick={()=>{handleClickOpen("assets/svg/webshop-new.svg")}}
              ></Box>
              <Box
                pt={1}
                component="a"
                // href={process.env.REACT_APP_PUBLIC_URL + "webshop.html"}
                onClick={() => { handleClickOpen("webshop.html") }}
                className={clsx(
                  classes.subMenuList,
                  commonClasses.cursorPointer
                )}
              >
                Webshop
              </Box>
            </Box>
            <Box textAlign="center" pb={1}

              className={clsx(headerClasses.menuItem, "beforeLogin")}

              display={props.username ? "none" : "block"}
            >
              <Box
                component="img"
                className={commonClasses.cursorPointer}
                width={20}
                src={
                  process.env.REACT_APP_CUSTOMER_PORTAL_URL +
                  "assets/svg/customer-new.svg"
                }
              //onClick={()=>{//}}
              ></Box>
              <Box
                pt={1}
                component="span"
                className={clsx(
                  classes.subMenuList,
                  commonClasses.cursorPointer
                )}
              >
                {"Customer"}
              </Box>

              <MenuCustomer />
            </Box>
            <Box
              textAlign="center"
              className={clsx(headerClasses.menuItem, "top-lastnav")}
              pb={1}
              display={props.username ? "block" : "none"}
            >
              <Box>
                <Box className={clsx("nav-avatar")} component="div">
                  <Box component="img" className={clsx(commonClasses.cursorPointer, "afterLoginIcon")} width={20} src={imgUrl != "" ? imgUrl : process.env.REACT_APP_CUSTOMER_PORTAL_URL + "assets/user_imgs/default_img.png"}
                    onClick={() => { onAccountclick(true) }} ></Box>
                </Box>
                <Box
                  pt={0.2}
                  component="span"
                  className={clsx(
                    classes.subMenuList,
                    commonClasses.cursorPointer
                  )}
                >
                  {props.username ? props.username : "Customer"}
                </Box>
                <Box className="signedin"
                  component="div"
                  color="green"
                  fontWeight="bold"
                  fontSize={11}
                >
                  {props.username ? "Signed In" : ""}
                </Box>
              </Box>

              <MenuHelp />
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
